export default __webpack_public_path__ + "static/media/favicon.ico.ce55eb26.png";